{
    "coordinates": [
        -22.373979732696156,
        143.03721390682017
    ],
    "tooltip": "Winton",
    "title": "Winton Formation",
    "country": "Australia",
    "period": "Cretaceous",
    "alt": "TODO"
}
